module.exports = {"130722100":"张北镇","130722101":"公会镇","130722102":"二台镇","130722103":"大囫囵镇","130722104":"小二台镇","130722106":"油篓沟镇","130722107":"大河镇","130722200":"台路沟乡","130722202":"馒头营乡","130722203":"二泉井乡","130722204":"单晶河乡","130722206":"海流图乡","130722207":"两面井乡","130722208":"大西湾乡","130722209":"郝家营乡","130722210":"白庙滩乡","130722212":"战海乡","130722213":"三号乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130722.json
// module id = 167
// module chunks = 0